module.exports = __webpack_public_path__ + "img/arrow-right.8ace7d88.svg";